import React, { Component } from "react";
import {
  Row,
  Navbar,
  Nav,
  Container,
  NavDropdown,
  Jumbotron,
  Col,
  Image
} from "react-bootstrap";

//import font-awesome from 'font-awesome';
//import { NavLink } from "react-router-dom";

class Header extends Component {
  render() {
    return (
      <React.Fragment>
      <Container fluid id="home">
      <Navbar fixed="top"  bg="light" variant="light"  expand="lg">
          <Navbar.Brand href="#home">Portfolio</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="justify-content-end">
                  <Nav.Link href="#home">Home</Nav.Link>
                  <Nav.Link href="#about">About Me</Nav.Link>
                  <Nav.Link href="#education">Education</Nav.Link>
                  <Nav.Link href="#certificates">Certificates</Nav.Link>
                  <NavDropdown title="Projects" id="basic-nav-dropdown">
                    <NavDropdown.Item href="https://github.com/samdevlops/">Github Projects</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="http://www.hostelers.epizy.com/index.html">Hostel Booking Website</NavDropdown.Item>
                    <NavDropdown.Item href="https://github.com/samdevlops/Timer-App">Timer App</NavDropdown.Item>
                    <NavDropdown.Item href="https://github.com/samdevlops/box-game">Box game</NavDropdown.Item>
                  </NavDropdown>
            </Nav>
            {
             // <Image className="nav-img" src="./images/travel.jpg" roundedCircle />
            }
          </Navbar.Collapse>
      </Navbar>
      <Jumbotron className="navi">
          <Row id="header">
              <Col>
                <h3>Hello! I'm</h3>
                <h1>Saurabh Mishra</h1>
              </Col>
          </Row>
        </Jumbotron>
      </Container>
      </React.Fragment>
    );
  }
}

export default Header;
